import React, {useEffect} from 'react';
import { useHistory } from 'react-router-dom';

const CmsLogin = () => {
    let history = useHistory();
    const page = new URLSearchParams(window.location.search).get('redirect');
    useEffect(() => {
        // Redirect to page after cms preview loaded
        document.addEventListener('cms-preview-loaded', () => {
            history.push(page);
        });

        // Trigger event to load cms iframe
        document.dispatchEvent(new CustomEvent('cms-preview-activated'));
    }, [history, page]);

    return ( 
        <div>
            Redirect to {page}
        </div>
     );
}
 
export default CmsLogin;